import React, { useEffect, useState } from "react";
import CustomDataTable from "../../../../../partials/content/CustomDataTable";
import { formatDate } from "../../../../../utils/utils";
import Illustration from "../../../../../partials/content/Illustration";
import { getLeadVisits } from "../../../../../services/crm/leadService";
import SlcVisitDetail from "../../slc/slcVisitDetail";
import { Badge } from "react-bootstrap";
import DialogLayout from "../../../../../partials/content/DialogLayout";
import ResponsiveEllipsis from "../../../../../partials/content/ResponsiveEllipsis";
import BootstrapTooltip from "../../../../../partials/content/BootstrapTooltip";
import { useGlobalData } from "../../../../../../provider/GlobalDataProvider";
function LeadVisits({ history, leadID }) {
  const { reload } = useGlobalData();
  const [visits, setVisits] = useState([]);
  const [openVisitDetail, setOpenVisitDetail] = useState(false);
  const [visitID, setVisitID] = useState(0);
  useEffect(() => {
    getLeadVisitsData(leadID);
  }, [leadID, reload]);

  const leadVisitDetailColumn = [
    {
      header: "Created At",
      field: "CreatedAt",
      type: "datetime",
    },
    {
      header: "Created By",
      field: "createdByName",
      type: "string",
    },
    {
      header: "Updated At",
      field: "UpdatedAt",
      type: "datetime",
    },
    {
      header: "Updated By",
      field: "updatedByName",
      type: "string",
    },
  ];

  return (
    <React.Fragment>
      {visits.length ? (
        <React.Fragment>
          <CustomDataTable
            data={visits}
            dataDetailColumns={leadVisitDetailColumn}
            onRefreshData={() => {
              getLeadVisitsData(leadID);
            }}
            columns={[
              {
                header: "Sales Card Name",
                field: "salesCard.title",
                body: (rowData) => (
                  <React.Fragment>
                    <ResponsiveEllipsis
                      text={rowData.salesCard.title}
                      maxLine="1"
                    />
                  </React.Fragment>
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Visit Status",
                field: "statusName",
                body: (rowData) => {
                  if (rowData.statusID === 1) {
                    return (
                      <Badge variant="warning">{rowData.statusName}</Badge>
                    );
                  } else if (rowData.statusID === 2) {
                    return (
                      <Badge variant="primary">{rowData.statusName}</Badge>
                    );
                  } else if (rowData.statusID === 3) {
                    return (
                      <Badge variant="success">{rowData.statusName}</Badge>
                    );
                  } else if (rowData.statusID === 9) {
                    return <Badge variant="danger">{rowData.statusName}</Badge>;
                  } else {
                    return <Badge variant="dark">{rowData.statusName}</Badge>;
                  }
                },
                sortable: true,
                filter: true,
              },
              {
                header: "Plan Visit Date",
                field: "planVisitDate",
                body: (rowData) => formatDate(rowData.planVisitDate),
                sortable: true,
                filter: true,
              },
              {
                header: "Actual Visit Date",
                field: "actVisitDate",
                body: (rowData) =>
                  formatDate(rowData.actVisitDate, true, false),
                sortable: true,
                filter: true,
              },
              {
                header: "Actions",
                body: (rowData) => (
                  <React.Fragment>
                    <BootstrapTooltip title="Visit Detail">
                      <button
                        type="button"
                        onClick={() => {
                          setVisitID(rowData.ID);
                          setOpenVisitDetail(true);
                        }}
                        className="btn btn-icon btn-label-success btn-circle btn-md mx-1"
                      >
                        <i className="fas fa-list-alt"></i>
                      </button>
                    </BootstrapTooltip>
                  </React.Fragment>
                ),
                sortable: false,
              },
            ]}
          />
        </React.Fragment>
      ) : (
        <React.Fragment>
          <Illustration
            imageSource="INVIFO CRM.png"
            guidance="You don't have any Journey Visits for this lead yet"
            guidanceLeftIcon="fas fa-info-circle kt-font-warning"
            size="md"
          ></Illustration>
          <div className="text-center py-3">
            <button
              type="button"
              className="btn btn-label-primary btn-md btn-pill btn-bold mx-1"
              onClick={() => {
                history.push("/crm/sales-journey");
              }}
            >
              <i className="fas fa-map-marker-alt"></i>
              Go To Sales Journey
            </button>
          </div>
        </React.Fragment>
      )}
      <DialogLayout
        open={openVisitDetail}
        title="Visit Detail"
        onCloseDialog={handleCloseVisitDetail}
      >
        <SlcVisitDetail
          visitID={visitID}
          onCloseDialog={handleCloseVisitDetail}
        />
      </DialogLayout>
    </React.Fragment>
  );

  function handleCloseVisitDetail() {
    setOpenVisitDetail(false);
  }

  async function getLeadVisitsData(leadID) {
    const response = await getLeadVisits(leadID);
    const { data } = response.data;
    setVisits(data.visits);
  }
}

export default LeadVisits;
